import React from "react";
import {
  Badge,
  Box,
  IconButton,
  Menu,
  MenuItem,
  Typography,
} from "@mui/material";
import NotificationsIcon from "@mui/icons-material/Notifications";
import dayjs from "dayjs";

export default function NotificationBell({
  unreadCount = 0,
  notifications = [],
  anchorEl = null,
  onOpen,
  onClose,
}) {
  return (
    <>
      <IconButton
        aria-label="notifications"
        sx={{ color: "#004f7d" }}
        onClick={onOpen}
      >
        <Badge badgeContent={unreadCount} color="error" max={9}>
          <NotificationsIcon />
        </Badge>
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={onClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        slotProps={{ paper: { sx: { minWidth: 280, maxWidth: 360 } } }}
      >
        {notifications.length === 0 ? (
          <MenuItem disabled>
            <Typography sx={{ fontSize: 13 }}>No notifications</Typography>
          </MenuItem>
        ) : (
          notifications.map((item) => (
            <MenuItem key={item.id} onClick={onClose}>
              <Box sx={{ display: "flex", flexDirection: "column", gap: 0.25 }}>
                <Typography sx={{ fontSize: 13 }}>{item.message}</Typography>
                <Typography sx={{ fontSize: 11, color: "text.secondary" }}>
                  {dayjs(item.timestamp).format("YYYY-MM-DD HH:mm:ss")}
                </Typography>
              </Box>
            </MenuItem>
          ))
        )}
      </Menu>
    </>
  );
}
